import React from 'react'
import EmpListContainer from '../../containers/employeemng/EmpListContainer'

const EmployeeListPage = () => {
  return <EmpListContainer/>
}

export default EmployeeListPage
